import dayjs from 'dayjs';

export const getDOBFromID = (idNo) => {
  let currDate = dayjs();

  let year = idNo.slice(0, 2);
  let month = idNo.slice(2, 4);
  let day = idNo.slice(4, 6);
  let currYear = currDate.year().toString().slice(2);

  if (year > 0 && year < parseInt(currYear)) {
    year = '20' + year;
  } else {
    year = '19' + year;
  }

  let jsDate = new Date(`${year}-${month}-${day}`);

  return dayjs(jsDate);
};

export function isValidID(message) {
  return this.test('isValidID', message, function (value) {
    const { path, createError } = this;

    if (!value) {
      return createError({ path, message: message ?? 'Required' });
    }

    let dob = getDOBFromID(value);

    if (dayjs().subtract(18, 'year').isBefore(dob)) {
      return createError({
        path,
        message: message ?? 'Applicant must be over 18 years of age',
      });
    }

    if (value[10] !== '1' && value[10] !== '0') {
      return createError({ path, message: message ?? 'Invalid ID number' });
    }

    return true;
  });
}

export function noWhiteSpace(message) {
  return this.test('noWhiteSpace', message, function (value) {
    const { path, createError } = this;

    if (!value) {
      return createError({ path, message: message ?? 'Required' });
    }

    if (value.includes(' ')) {
      return createError({ path, message: message ?? 'Cannot contain spaces' });
    }

    return true;
  });
}

export function isValidGender(ref, message) {
  return this.test('isValidGender', message, function (value) {
    const { path, createError } = this;

    let idGender = this.resolve(ref).slice(6, 10);
    if (value === 'M' && parseInt(idGender) < 5000) {
      return createError({
        path,
        message: message ?? 'Gender does not match ID',
      });
    }
    if (value === 'F' && parseInt(idGender) >= 5000) {
      return createError({
        path,
        message: message ?? 'Gender does not match ID',
      });
    }

    return true;
  });
}

export function isOver18(message) {
  return this.test('isOver18', message, function (value) {
    const { path, createError } = this;

    let dob = dayjs(value);
    let now = dayjs();

    if (now.subtract(18, 'year').isBefore(dob)) {
      return createError({
        path,
        message: message ?? 'Must be older that 18',
      });
    }

    return true;
  });
}

export function isValidYAR(ref, message) {
  return this.test('isValidYAR', message, function (value) {
    const { path, createError } = this;

    // console.log(this.resolve(ref));

    let dob = dayjs(getDOBFromID(this.resolve(ref)));
    let now = dayjs();

    if (now.subtract(value, 'year').isBefore(dob)) {
      return createError({
        path,
        message: message ?? 'Years at residence cannot be greater than age',
      });
    }
    if (value < 1) {
      return createError({
        path,
        message: message ?? 'Years at residence cannot be less than 1',
      });
    }

    return true;
  });
}
